import { RouteRecordRaw } from "vue-router";

export const toolsRoutes: RouteRecordRaw[] = [
  {
    path: "/create-content",
    name: "create-content",
    redirect: { name: "content" },
    meta: {
      activityArea: "content",
      title: "Create content with AI",
      added: "2022-08-04",
      updated: "2023-06-01",
      text: "Create content with AI",
      icon: "fyr-ai",
      description:
        "Use Fyr's advanced machine learning algorithms to help you create new content ",
      requiresAuth: true,
      isDirect: true,
      contentWidth: "wide",
      breadcrumb: false,
    },
    component: () => import("@/views/Tools/ContentLab.vue"),
    children: [
      {
        path: "content",
        name: "content",
        meta: {
          title: "Content Lab",
          breadcrumb: false,
          shell: "application",
        },
        component: () => import("@/views/Tools/ContentLab/ContentCreator.vue"),
      },
    ],
  },
  {
    path: "/utm-builder",
    name: "utm-builder",
    meta: {
      title: "UTM URL Builder",
      text: "UTM URL builder",
      description:
        "Get insight about where users are coming from and what engages users",
      icon: "link-lucide",
      requiresAuth: true,
      isDirect: true,
      breadcrumb: false,
    },
    component: () => import("@/views/Tools/UtmBuilder.vue"),
  },
];
